import moment from 'moment';
import Box from '@mui/material/Box';
import { Form } from 'components/@shared/Form/Form';
import Stack from '@mui/material/Stack';
import { FormTextField } from 'components/@shared/Form/TextField';
import { GoBackButton } from 'components/@shared/GoBackButton';
import Button from '@mui/material/Button';
import { InvoiceFormData } from 'types/invoice';
import { validationSchema } from './validation';
import { InvoiceTotalBlock } from './InvoiceTotalBlock';
import { initialInvoiceFormDataValues } from './constants';
import { FormDateTimePicker } from 'components/@shared/Form/FormDateTimePicker';

interface Props {
    initialData?: InvoiceFormData;
    onSubmit: (values: InvoiceFormData) => void;
}

const afterOneHour = moment().add(1, 'hour');

export const InvoiceForm = ({ initialData = initialInvoiceFormDataValues, onSubmit }: Props) => {
    return (
        <Form initialValues={initialData} validationSchema={validationSchema} onSubmit={onSubmit}>
            <Stack gap={2} pt={3} pb={3} maxWidth={1000} mx="auto">
                <FormTextField name="title" label="Title" fullWidth size="small" />
                <FormTextField name="description" label="Description" fullWidth size="small" />
                <FormDateTimePicker name="scheduledPayDate" label="Pay date" minDateTime={afterOneHour} />
                <InvoiceTotalBlock />
                <Box display="flex" justifyContent="space-between" alignItems="center" mt={3}>
                    <GoBackButton />
                    <Button variant="contained">Apple Pay</Button>
                    <Button variant="contained" type="submit">
                        Save
                    </Button>
                </Box>
            </Stack>
        </Form>
    );
};
